import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./ImgPop.module.scss";

// img
import i1 from "../../../Assets/images/no-img.png";

const ImgPop = ({ img, setImg }) => {
  const handleImgPop = () => setImg(null);

  return (
    <>
      <Modal
        show={img}
        className={`${styles.ImgPop} transparentModal`}
        onHide={handleImgPop}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="p-0">
          <Button
            onClick={handleImgPop}
            className="border-0 p-0 position-absolute"
            style={{ right: 10, top: 10 }}
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="21"
              viewBox="0 0 15 21"
              fill="none"
            >
              <path
                d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
                fill="black"
              />
            </svg>
          </Button>
          <img src={img || i1} alt="" className="img-fluid w-100" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImgPop;
